import VoucherClaimCreateMutation from '../entities/voucherClaimCreateMutation';

const VoucherClaimCreateItemTransformationBeforeSave = (item: VoucherClaimCreateMutation) => {
    const transformedData = {
        ...item      ,
        source: item.sourceEnumDescription?.value,
        variant: item.variantEnumDescription?.value,
    } as { [key: string]: any };

    return transformedData;
};

export default VoucherClaimCreateItemTransformationBeforeSave;